import {
  Product,
  Offer,
  AggregateOffer,
  AggregateRating,
  Organization,
  Person,
  ListItem,
  ItemList,
  BreadcrumbList,
  FAQPage,
  QAPage,
  Review,
  SoftwareApplication,
  ImageObject,
  Dataset,
  Article,
  HowToSection,
  WebPageElement,
  WebPage,
  create
} from './rich-results';
import {RichResultsTypes} from '../enum/rich-results-types.enum';

export const buildProduct = (d: Omit<Product, '@context' | '@type'>) =>
  create<Product>(RichResultsTypes.Product, d);

export const buildOffer = (d: Omit<Offer, '@context' | '@type'>) =>
  create<Offer>(RichResultsTypes.Offer, d);

export const buildAggregateOffer = (d: Omit<AggregateOffer, '@context' | '@type'>) =>
  create<AggregateOffer>(RichResultsTypes.AggregateOffer, d);

export const buildAggregateRating = (d: Omit<AggregateRating, '@context' | '@type'>) =>
  create<AggregateRating>(RichResultsTypes.AggregateRating, d);

export const buildReview = (d: Omit<Review, '@context' | '@type'>) =>
  create<Review>(RichResultsTypes.Review, d);

export const buildOrganization = (d: Omit<Organization, '@context' | '@type'>) =>
  create<Organization>(RichResultsTypes.Organization, d);

export const buildPerson = (d: Omit<Person, '@context' | '@type'>) =>
  create<Person>(RichResultsTypes.Person, d);

export const buildListItem = (d: Omit<ListItem, '@context' | '@type'>) =>
  create<ListItem>(RichResultsTypes.ListItem, d);

export const buildItemList = (d: Omit<ItemList, '@context' | '@type'>) =>
  create<ItemList>(RichResultsTypes.ItemList, d);

export const buildBreadcrumbList = (d: Omit<BreadcrumbList, '@context' | '@type'>) =>
  create<BreadcrumbList>(RichResultsTypes.BreadcrumbList, d);

export const buildFAQPage = (d: Omit<FAQPage, '@context' | '@type'>) =>
  create<FAQPage>(RichResultsTypes.FAQPage, d);

export const buildQAPage = (d: Omit<QAPage, '@context' | '@type'>) =>
  create<QAPage>(RichResultsTypes.QAPage, d);

export const buildSoftwareApplication = (d: Omit<SoftwareApplication, '@context' | '@type'>) =>
  create<SoftwareApplication>(RichResultsTypes.SoftwareApplication, d);

export const buildImageObject = (d: Omit<ImageObject, '@context' | '@type'>) =>
  create<ImageObject>(RichResultsTypes.ImageObject, d);

export const buildDataset = (d: Omit<Dataset, '@context' | '@type'>) =>
  create<Dataset>(RichResultsTypes.Dataset, d);

export const buildArticle = (d: Omit<Article, '@context' | '@type'>) =>
  create<Article>(RichResultsTypes.Article, d);

export const buildHowToSection = (d: Omit<HowToSection, '@context' | '@type'>) =>
  create<HowToSection>(RichResultsTypes.HowToSection, d);

export const buildWebPageElement = (d: Omit<WebPageElement, '@context' | '@type'>) =>
  create<WebPageElement>(RichResultsTypes.WebPageElement, d);

export const buildWebPage = (d: Omit<WebPage, '@context' | '@type'>) =>
  create<WebPage>(RichResultsTypes.WebPage, d);
